import { useCallback } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Drawer from "@mui/material/Drawer";

import { useGetResidentQuery } from "@redux/residents/residentsApi";

import ResidentDetailsContent from "./ResidentDetailsContent/";

export default function ResidentDetails() {
  const { residentId: id } = useParams();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const {
    currentData: resident,
    isFetching,
    isError,
  } = useGetResidentQuery(id ? { id } : skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const onClose = useCallback(() => {
    navigate({
      pathname: "../",
      search: createSearchParams(searchParams).toString(),
    });
  }, [searchParams]);

  return (
    <Drawer
      anchor="right"
      open={!!id}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "50%",
          },
          maxWidth: { xl: "870px" },
        },
      }}>
      <ResidentDetailsContent
        isError={isError}
        isLoading={isFetching || !id}
        resident={resident}
        onClose={onClose}
      />
    </Drawer>
  );
}
